module.exports = __webpack_public_path__ + "img/auxerre-logo-icon.6eef4f24.png";